// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__1l4bl","ProductItemImg":"styles_ProductItemImg__1zSVc","Hovered":"styles_Hovered__1HgBS","BasketItemImg":"styles_BasketItemImg__xzG3J"};